import gql from 'graphql-tag';
import User from '../../entity/User';
import { UserStub } from '@kaizenplatform/kaizen-offer-entity';
import { UserId } from '@kaizenplatform/kaizen-id-entity';
import GraphQLClient from '../../adapter/GraphQLClient';

class UserWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ offerGraphqlClient }: { offerGraphqlClient: GraphQLClient }) {
    this.graphqlClient = offerGraphqlClient;
  }

  public getStubUserById = async (): Promise<User> => {
    const result = {
      User: new UserStub(),
    };
    return User.fromJSON(result.User);
  };

  public getUserById = async (userId: UserId): Promise<User> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query User($userId: ID!) {
            User(userId: $userId) {
              id
              name
              profileImageUrl
              description
              createdAt
            }
          }
        `,
        {
          userId,
        },
      );

      if (result.User === null) {
        throw new UserNotFound({
          userId,
        });
      }

      return User.fromJSON(result.User) as User;
    } catch {
      throw new RequestFailed({ userId });
    }
  };
}

export class UserNotFound extends Error {
  public readonly name = 'UserNotFound';
  public readonly message: string;
  public readonly userId: UserId;

  constructor({ userId }: { userId: UserId }) {
    super();

    this.userId = userId;
    this.message = `User (id = ${userId}) is not found.`;
  }
}

export class RequestFailed extends Error {
  public readonly name = 'PageNotFound';
  public readonly userId: UserId;

  constructor({ userId }: { userId: UserId }) {
    super();
    this.userId = userId;
    this.message = `Request error (UserId = ${userId}). `;
  }
}

export default UserWebApi;
